import {
  EnumTipoOperacion,
  postOperation,
  apiFetchConfigOperacionBalanceByOperationType,
  EnumTipoSujeto,
  patchOperation,
  deleteOperations,
  apiOperacionesBuyAndSellGET,
  EnumOperationState,
  EnumEstadoOperacionConciliar,
  apiOperacionesGETByFlangesIds,
  Operacion,
  apiBatch,
  EnumTipoElemLog,
  EnumCommodity,
  EnumSubTipoElemLog,
  isOfTypeLogisticElementSubTypePoint,
  EnumSubtipoSujeto,
  TradeListItem,
  EnumEstadoOperacionBuyAndSell,
  isOperationState
} from '../../api'
import {
  buyAndSellListItemsMapperApiToVM,
  buyAndSellMapperToAPI_POST,
  operationsBalanceConfigMapperAPItoModel,
  counterpartsMapperToDropDown,
  buyAndSellMapperToAPI_PATCH,
  buyAndSellMapperToAPI_DELETE,
  buyAndSellSendMapperToAPI_POST,
  buyAndSellMapperCancelToAPI_PATCH,
  buyAndSellToCancelBatchRequest,
  buyAndSellToDeleteBatchRequest,
  tradeListItemsToSelectOption
} from './buyandsell.mapper'
import { ApiTrades } from '../../api/Pioneer/endpoints/trades/trades.api'
import { fetchSubjectsByTypesAPI } from '../../api/Pioneer/endpoints/subjects/subjects.api'
import { apiFetchLogisticElementsSelectOptionsBySubtypes } from '../../api/Pioneer/endpoints/logisticElements/logisticElements.api'
import { SelectOption } from '@globaleris/ui.library'
import { DataTableActionConfiguration, ActionIcons } from '../../model'
import i18n from '../../i18n'

import { getActiveBalanceZone, getActiveCompany, notifyError } from '../../redux'
import { enumKeyToValue, enumValueToKey, enumEnumToValueString } from '../../helpers'
import moment from 'moment'
import { ApiBuyAndSell } from '../../api/oData/endpoints/operaciones/compraVenta.api'
import { ServiceResponse } from '../../model/serviceResponse'
import {
  createErrorServiceBatchResponse,
  createErrorServiceResponse,
  createGenericErrorServiceBatchResponse,
  createSuccessServiceBatchResponse,
  createSuccessServiceResponse
} from '../../helpers/serviceResponseHelper'
import { AddMassiveBuyAndSellModel, BuyAndSellModel } from './buyandsell.model'
import { BatchResponse } from '../../api/oData/responses'
import { ServiceBatchResponse } from '../../model/serviceBatchResponse'
import { getGasDay } from '../../helpers/gasDayHelper'
import { apiMassiveDispatchesPOST } from '../../api/Pioneer/endpoints/dispatches'
import { apiGetTradesByCode } from '../../api/Pioneer/endpoints/trades/trades.api'
import { mapAddTradeFromMassiveBSOpsRequest, mapAddTradeRequest } from '../trades/trades.mapper'
import { apiGetBuyAndSellOperations } from '../../api/Pioneer/endpoints/operations/operations.api'

const apiBuyAndSell = new ApiBuyAndSell()
const apiTrades = new ApiTrades()

export const fetchBuyAndSellListItems = async (
  startDate: Date | undefined,
  endDate: Date | undefined,
  counterpart?: number,
  operationType?: number,
  stateBuyAndSell?: number,
  registerDate?: Date,
  tradeCode?: string
): Promise<ServiceResponse<any>> => {
  const operationTypesToFilter = operationType
    ? [enumKeyToValue(EnumTipoOperacion, operationType)]
    : [
        enumValueToKey(EnumTipoOperacion, EnumTipoOperacion.Compra),
        enumValueToKey(EnumTipoOperacion, EnumTipoOperacion.Venta)
      ]

  return await apiOperacionesBuyAndSellGET(
    operationTypesToFilter,
    startDate,
    endDate,
    counterpart,
    stateBuyAndSell,
    registerDate,
    tradeCode,
    getActiveBalanceZone(),
    getActiveCompany()
  )
    .then(res => {
      return createSuccessServiceResponse(buyAndSellListItemsMapperApiToVM(res))
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const searchBuyAndSellOperations = async ({
  startDate,
  endDate,
  counterparts,
  operationTypes,
  state: stateBuyAndSell,
  registerDate,
  tradeCode
}: {
  startDate: Date | undefined
  endDate: Date | undefined
  counterparts?: number[]
  operationTypes?: number[]
  state?: number[]
  registerDate?: Date
  tradeCode?: string
}): Promise<ServiceResponse<any>> => {
  // Si no se provee operationTypes, se buscan operaciones de tipo Compra y Venta
  const operationTypesToFilter =
    operationTypes && operationTypes.length === 1
      ? [enumValueToKey(EnumTipoOperacion, operationTypes[0])]
      : [
          enumValueToKey(EnumTipoOperacion, EnumTipoOperacion.Compra),
          enumValueToKey(EnumTipoOperacion, EnumTipoOperacion.Venta)
        ]

  let state: string[] = []
  let stateTSO: string[] = []

  if (stateBuyAndSell && stateBuyAndSell.length > 0) {
    stateBuyAndSell.forEach(stateItem => {
      let stateBuyAndSellFilterString: string | undefined
      stateBuyAndSellFilterString = enumValueToKey(EnumEstadoOperacionBuyAndSell, stateItem)
      if (!stateBuyAndSellFilterString) {
        return
      }
      if (isOperationState(stateItem)) {
        state.push(stateBuyAndSellFilterString)
      } else {
        stateTSO.push(stateBuyAndSellFilterString)
      }
    })
  }

  return apiGetBuyAndSellOperations({
    operationTypes: operationTypesToFilter,
    startDate,
    endDate,
    counterpart: counterparts,
    state: state.length > 0 ? state : undefined,
    stateTSO: stateTSO.length > 0 ? stateTSO : undefined,
    registerDate: registerDate,
    tradeCode
  })
    .then(res => {
      return createSuccessServiceResponse(buyAndSellListItemsMapperApiToVM(res))
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchBuyAndSellListItemsByIds = async (
  items: number[]
): Promise<ServiceResponse<any>> => {
  return await apiOperacionesGETByFlangesIds(items)
    .then(res => {
      return createSuccessServiceResponse(buyAndSellListItemsMapperApiToVM(res))
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchLogisticElementsToItems = async (): Promise<SelectOption[]> => {
  return await fetchLogisticElements()
}

export const fetchLogisticElements = async (): Promise<SelectOption[]> => {
  return await apiFetchLogisticElementsSelectOptionsBySubtypes(
    await apiFetchConfigOperacionBalanceByOperationType([
      EnumTipoOperacion.Compra,
      EnumTipoOperacion.Venta
    ]).then(response => {
      return operationsBalanceConfigMapperAPItoModel(response).map(
        item => item.logisticElementSubType
      )
    }),
    getActiveBalanceZone()?.id
  )
}

export let fetchSubjectsByTypeToItems = async (): Promise<any> => {
  return await fetchSubjectsByTypesAPI(
    [EnumTipoSujeto.Mayorista, EnumTipoSujeto.ConsumidorDirectoMercado],
    EnumCommodity.GasNatural,
    getActiveBalanceZone()?.id
  ).then(counterpartsMapperToDropDown)
}

//#region DELETE

export const canDeleteMassive = (items: any[]): boolean => {
  return items?.find(x => x.canDelete === false) === undefined
}

export const GetCanDeleteMassive = (items: any[]): any[] => {
  return items.filter(x => x.canDelete === true)
}

export const canDelete = (
  state: EnumOperationState,
  date: Date,
  subjectSubtype: EnumSubtipoSujeto
): boolean => {
  return (
    subjectSubtype != EnumSubtipoSujeto.Mercado &&
    (state === EnumOperationState.Borrador || state === EnumOperationState.Anulada) &&
    moment(date).isSameOrAfter(moment(), 'day')
  )
}

export const deleteOperation = async (item: BuyAndSellModel): Promise<ServiceResponse<any>> => {
  return deleteOperations(buyAndSellMapperToAPI_DELETE(item))
    .then(() => {
      return createSuccessServiceResponse(true)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const deleteMassive = async (items: BuyAndSellModel[]): Promise<ServiceBatchResponse> => {
  return await apiBatch(buyAndSellToDeleteBatchRequest(items))
    .then((response: BatchResponse) => {
      const errors = response.responses.filter(x => x.status !== 204)
      if (errors.length > 0) {
        return createErrorServiceBatchResponse(response.responses)
      }
      return createSuccessServiceBatchResponse()
    })
    .catch(error => {
      return createGenericErrorServiceBatchResponse(error)
    })
}

//#endregion

//#region CANCEL

export const canPastCancelMassive = (items: any[]): boolean => {
  return items.find(x => moment(x.date).toDate() < moment().startOf('day').toDate()) === undefined
}

export const canCancelMassive = (items: any[]): boolean => {
  return items.find(x => x.canCancel === false) === undefined
}

export const GetCanCancelMassive = (items: any[]): any[] => {
  return items.filter(x => x.canCancel === true)
}

export const cancelMassive = async (items: BuyAndSellModel[]): Promise<ServiceBatchResponse> => {
  return await apiBatch(buyAndSellToCancelBatchRequest(items))
    .then((response: BatchResponse) => {
      const errors = response.responses.filter(x => x.status !== 204)
      if (errors.length > 0) {
        return createErrorServiceBatchResponse(response.responses)
      }
      return createSuccessServiceBatchResponse()
    })
    .catch(error => {
      return createGenericErrorServiceBatchResponse(error)
    })
}

export const canCancel = (
  state: EnumOperationState,
  date: Date,
  subjectSubtype: EnumSubtipoSujeto
): boolean => {
  return (
    subjectSubtype != EnumSubtipoSujeto.Mercado &&
    state !== EnumOperationState.Borrador &&
    state !== EnumOperationState.Anulada &&
    moment(date).isSameOrAfter(moment(), 'day')
  )
}

export const cancel = async (operation: BuyAndSellModel): Promise<boolean> => {
  return apiBuyAndSell
    .cancel(buyAndSellMapperCancelToAPI_PATCH(operation))
    .then(() => {
      return true
    })
    .catch(() => {
      notifyError(i18n.t('buyAndSell:notifications.error.cancel'))
      return false
    })
}

//#endregion

//#region SEND

export const canPastSendMassive = (items: any[]): boolean => {
  return items.find(x => moment(x.date).toDate() < moment().startOf('day').toDate()) === undefined
}

export const canSendMassive = (items: any[]): boolean => {
  return items?.find(x => x.canSend === false) === undefined
}

export const GetCanSendMassive = (items: any[]): any[] => {
  return items.filter(x => x.canSend === true)
}

export const canSend = (
  state: EnumOperationState,
  stateTSO: EnumEstadoOperacionConciliar,
  date: Date,
  logisticElementType: EnumTipoElemLog,
  cantidad?: number,
  cantidadTSO?: number
): boolean => {
  return (
    //Se puede enviar cuando es a presente/futuro, el elemento logítico no es Pto y...
    moment(date).isSameOrAfter(moment(), 'day') &&
    logisticElementType !== EnumTipoElemLog.Punto &&
    //1. No está en Pte Conciliar y los estados Borrador, PteReenvío, Rechazado y EnviadoKO
    (((state === EnumOperationState.Borrador ||
      state === EnumOperationState.PendienteRenvio ||
      state === EnumOperationState.Rechazado ||
      state === EnumOperationState.EnviadoKO) &&
      stateTSO !== EnumEstadoOperacionConciliar.PdteConciliar) ||
      //2. Está en Formalizado Modificado y no ha habido cambio de cantidad (64277)
      (state === EnumOperationState.Enviada &&
        stateTSO === EnumEstadoOperacionConciliar.FormalizadoModificacion &&
        cantidad === cantidadTSO))
  )
}

const canSendToLogisticElement = (logisticElementSubType: EnumSubTipoElemLog): boolean => {
  // Only Logistic Elements with subtype !== 'punto' can be sent to TSO.
  if (
    isOfTypeLogisticElementSubTypePoint(
      enumKeyToValue(EnumSubTipoElemLog, logisticElementSubType).toString()
    )
  ) {
    return false
  }
  return true
}

export const sendOperationsMassive = async (items: BuyAndSellModel[]): Promise<boolean> => {
  return await apiMassiveDispatchesPOST(
    buyAndSellSendMapperToAPI_POST(items, getActiveCompany()?.id!)
  )
    .then(() => {
      return true
    })
    .catch(() => {
      notifyError(i18n.t('buyAndSell:notifications.error.sendMassive'))
      return false
    })
}

//#endregion

//#region ADD

export const addByTrade = async (
  data: AddMassiveBuyAndSellModel
): Promise<ServiceResponse<any>> => {
  return await apiTrades
    .CreateTrade(
      mapAddTradeFromMassiveBSOpsRequest(
        data,
        getActiveCompany()?.id!,
        getActiveBalanceZone()?.id!,
        data.operationType
      )
    )
    .then(() => {
      return createSuccessServiceResponse(undefined)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

// export const addMassive = async (
//   item: AddMassiveBuyAndSellModel
// ): Promise<ServiceBatchResponse> => {
//   item.stateTSO = EnumOperationState.Borrador
//   return await apiBatch(
//     buyAndSellToAddBatchRequest(item, getActiveCompany()?.id!, getActiveBalanceZone()?.code!)
//   )
//     .then((response: BatchResponse) => {
//       const errors = response.responses.filter(x => x.status !== 201)
//       if (errors.length > 0) {
//         return createErrorServiceBatchResponse(response.responses)
//       }
//       return createSuccessServiceBatchResponse()
//     })
//     .catch(error => {
//       return createGenericErrorServiceBatchResponse(error)
//     })
// }

export const add = (operation: any): Promise<ServiceResponse<any>> =>
  postOperation(buyAndSellMapperToAPI_POST(operation))
    .then(() => {
      return createSuccessServiceResponse(undefined)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })

//#endregion

//#region EDIT

export const canEdit = (date: Date, subjectSubtype: EnumSubtipoSujeto): boolean => {
  return (
    subjectSubtype != EnumSubtipoSujeto.Mercado &&
    moment(date).isSameOrAfter(moment(getGasDay()), 'day')
  )
}

export const edit = async (operation: any): Promise<ServiceResponse<any>> => {
  return await patchOperation(
    buyAndSellMapperToAPI_PATCH(operation)
  )
    .then(() => {
      return createSuccessServiceResponse(undefined)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

//#endregion

//#region Operation global actions

export const filterApplicableActionsConfiguration = (
  item: BuyAndSellModel,
  configurations: Array<DataTableActionConfiguration>
): Array<DataTableActionConfiguration> => {
  let applicableActionsConfiguration: Array<DataTableActionConfiguration> = []
  configurations.forEach(configuration => {
    switch (configuration.icon) {
      case ActionIcons.WARNING: {
        if (
          ((item.sentQuantity && item.quantity !== item.sentQuantity) ||
            (item.quantityTSO && item.quantity !== item.quantityTSO)) &&
          (item.state === EnumOperationState.PendienteRenvio ||
            item.state === EnumOperationState.Borrador)
        ) {
          applicableActionsConfiguration.push(configuration)
        }
        break
      }
      case ActionIcons.ERROR: {
        if (
          ((item.sentQuantity && item.quantity !== item.sentQuantity) ||
            (item.quantityTSO && item.quantity !== item.quantityTSO)) &&
          (item.state === EnumOperationState.Enviada ||
            item.state === EnumOperationState.Rechazado ||
            item.state === EnumOperationState.EnviadoKO)
        ) {
          applicableActionsConfiguration.push(configuration)
        }
        break
      }
    }
  })

  return applicableActionsConfiguration
}

export const getGlobalActionsConfiguration = (): Array<DataTableActionConfiguration> => {
  return [getQuantityDisagreementAction(), getStateDisagreementAction()]
}

const getQuantityDisagreementAction = (): DataTableActionConfiguration => {
  return {
    icon: ActionIcons.WARNING,
    tooltip: i18n.t('buyAndSell:dataTable.tooltips.quantityDisagreement')
  }
}

const getStateDisagreementAction = (): DataTableActionConfiguration => {
  return {
    icon: ActionIcons.ERROR,
    tooltip: i18n.t('buyAndSell:dataTable.tooltips.stateDisagreement')
  }
}

//#endregion

//#region Retries

export const checkOperationsState = async (
  operationIds: any,
  desiredStates: EnumOperationState[]
): Promise<BuyAndSellModel[]> => {
  return await apiBuyAndSell.fetch(operationIds).then(response => {
    let updatedOperations: Operacion[] = []
    response.forEach(op => {
      if (desiredStates.some(x => x === op.estadoOperacion)) {
        updatedOperations.push(op)
      }
    })
    return buyAndSellListItemsMapperApiToVM(updatedOperations)
  })
}

//#endregion

// Get codTrades for searchfieldInput (Buy and Sell)
export const fetchTradesByCode = async (query: string): Promise<SelectOption[]> => {
  return await apiGetTradesByCode(query)
    .then(res => {
      return tradeListItemsToSelectOption(res)
    })
    .catch(error => {
      return []
    })
}
